// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as BlacklistPartnerRepoConfig from "./BlacklistPartnerRepoConfig.bs.js";
import * as BlacklistPartnerPayloadMapper from "../entity-mapper/BlacklistPartnerPayloadMapper.bs.js";

function blacklistPartner(payload, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/tns/partner/blacklist";
  var encodedPayload = JSON.stringify(BlacklistPartnerPayloadMapper.execute(payload));
  return NetworkV2$Catalyst.post(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, encodedPayload, undefined, /* Include */2, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(BlacklistPartnerRepoConfig.BlacklistPartnerResponseConverter.execute, result);
                        });
            });
}

var BlacklistPartnerRepo = {
  blacklistPartner: blacklistPartner
};

export {
  BlacklistPartnerRepo ,
  
}
/* Config Not a pure module */
